import { jsxs as e, Fragment as r, jsx as C } from "react/jsx-runtime";
const t = () => /* @__PURE__ */ e(r, { children: [
  /* @__PURE__ */ C("path", { d: "M17 19H20M20 19H23M20 19V16M20 19V22", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ C(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.15808 5.46164C7.6956 6.14152 6.97648 6.61351 6.15892 6.77376C4.32215 7.13378 3 8.71438 3 10.5502V14.2564C3 15.7336 3 16.8824 3.45625 17.76C3.85759 18.5319 4.49797 19.1595 5.28563 19.5528C6.18107 20 7.35327 20 9.69768 20H14.3023C14.6484 20 14.9689 20 15.2667 19.9986C15.0971 19.7047 15 19.3637 15 19C15 17.8954 15.8954 17 17 17H18V16C18 14.8954 18.8954 14 20 14C20.3643 14 20.7058 14.0974 21 14.2676C21 14.2639 21 14.2601 21 14.2564V14.2564V10.5502C21 8.71438 19.6779 7.13378 17.8411 6.77376C17.0235 6.61351 16.3044 6.14152 15.8419 5.46164L15.8153 5.42251C15.2108 4.5338 14.1931 4 13.1033 4H10.8968C9.80694 4 8.78922 4.5338 8.1847 5.42251L8.15808 5.46164ZM15.3488 12.8205C15.3488 14.6331 13.8496 16.1026 12 16.1026C10.1505 16.1026 8.65117 14.6331 8.65117 12.8205C8.65117 11.0079 10.1505 9.53846 12 9.53846C13.8496 9.53846 15.3488 11.0079 15.3488 12.8205Z",
      fill: "currentColor"
    }
  )
] });
export {
  t as default
};
